/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SettingsArrowUpIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB80lEQVR4nM1Vy04VQRBl586AgnHJF7BW9sjonXqMoaeKhyHhC9zxCyZu1IArY/gNViaw0QgLxRijCQk/QSDhYarvDDY9t2fwehd2UpmZ6q5zqus1Y2P/y0LSt0ByboIsmyMFz7LsFpCeIeulib2bbigwIplGljdE5Xygm63Br0iK8sGf/XIeSF6b7Q3A9agCuUCSLSIRJN1vELB89nssm/5sX3/USmJexED4l2IYSYKc5VHgzTByYRitYQKSjaG9Z33fCu4JWMuGMclPRF1gfnY3y5ZvI2rhdfG5QlwS2Mou58WHwLIXGf4y4Ph8r7c0Aaw/osTvWcU1SrhuooFXL9JeAcvTRKKtITeCuOtxKq693tJEioBodTxdTXo8KoITIFl/4tx9E3vv6wICa5ZwFESVUSZDBDqTszxu6AvNkPXlTZN86Jy7kyLxts5NAcknYPmY54uTXeNCBtzk0PRmbBVlnl8DZ/kaxP67hSpJYPOno6FO6rDE4J0kVexaRwWQPq/BkfSg34jV04t8q55fGuGyMd01DlyVD2D9UIN7smq/KFbuXd2KdLt1XPvpiroQJr7uamR9ZyQGXn37/eB228j6YlCSpw0YCp2rdVZdcYgauQsI/umXCaSnyLo2UgJbNlvqnz6Qvho5QddCkl1g3Yk3fgMRXxZaQalqWAAAAABJRU5ErkJggg==)
 */
export const SettingsArrowUpIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9.97 2.65c0-.76.4-1.56 1.16-1.62a11.15 11.15 0 0 1 1.74 0c.76.06 1.16.86 1.16 1.62 0 .92.37 1.68 1.03 1.96.66.27 1.46 0 2.11-.66.54-.53 1.4-.81 1.97-.32.44.38.85.79 1.23 1.23.5.58.21 1.43-.32 1.97-.65.65-.93 1.45-.66 2.1.28.67 1.04 1.03 1.96 1.04.76 0 1.56.4 1.62 1.16a11.17 11.17 0 0 1 0 1.74c-.03.38-.25.67-.55.86-.17.11-.38.06-.53-.08l-.77-.77a3 3 0 0 0-4.24 0l-.86.86a.2.2 0 0 1-.28 0 .2.2 0 0 1-.04-.22A3.99 3.99 0 0 0 12 8a4 4 0 1 0 1.52 7.7.2.2 0 0 1 .22.04.2.2 0 0 1 0 .28l-.86.86a3 3 0 0 0 .7 4.76c.22.12.37.37.26.6-.2.4-.52.7-.97.73a11.12 11.12 0 0 1-1.74 0c-.76-.06-1.16-.86-1.16-1.62 0-.92-.37-1.68-1.03-1.96-.66-.27-1.46 0-2.11.66-.54.53-1.4.81-1.97.32-.44-.38-.85-.79-1.23-1.23-.5-.58-.21-1.43.32-1.97.65-.65.93-1.45.66-2.1-.28-.67-1.04-1.03-1.96-1.04-.76 0-1.56-.4-1.62-1.16a11.15 11.15 0 0 1 0-1.74c.06-.76.86-1.16 1.62-1.16.92 0 1.68-.37 1.96-1.03.27-.66 0-1.46-.66-2.11-.53-.54-.81-1.4-.32-1.97.38-.44.79-.85 1.23-1.23.58-.5 1.43-.21 1.97.32.65.65 1.45.93 2.1.66.67-.28 1.03-1.04 1.04-1.96Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18.3 14.3a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1-1.4 1.4L20 17.42V23a1 1 0 0 1-2 0v-5.59l-2.3 2.3a1 1 0 0 1-1.4-1.42l4-4Z"
        className={colorClass}
      />
    </svg>
  );
};
